import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { CandidateCommentService } from '../../../service/candidate-comment/candidate-comment.service';
import { CandidateComment } from '../../../class/candidate-comment';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
declare var google: any;

@Component({
  selector: 'app-candidate-comment',
  templateUrl: './candidate-comment.component.html',
  styleUrls: ['./candidate-comment.component.scss']
})
export class CandidateCommentComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoCandidateComment: CandidateComment;
    public candidateCommet: CandidateComment;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public candidateCommetService: CandidateCommentService,
        private activatedRoute: ActivatedRoute,
        private mapsAPILoader: MapsAPILoader) {
    }

    ngOnInit() {
    }

    public cancelCandidateComment () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidate-comments/candidate-comment/candidate-comment.component.ts